import { render } from "./importSoal.vue?vue&type=template&id=764e2fc5&scoped=true"
import script from "./importSoal.vue?vue&type=script&lang=js"
export * from "./importSoal.vue?vue&type=script&lang=js"

import "./importSoal.vue?vue&type=style&index=0&id=764e2fc5&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764e2fc5"]])

export default __exports__